import React, { useState } from 'react';

// import { useTranslation } from 'react-i18next';
import UsersList from '../../../components/reusable/users-list/UsersList';
import { useStyles } from './AllUsers.styles';
import theme from '../../../styles/theme';
import { useLazyLoadGeneral } from '../../../hooks/use-lazy-load-general';
import { IUser } from '../../../types/interfaces/user';
import { Box } from '@mui/material';
import { useLazyGetUsers } from '../../../services/redux/api/usersApi';
import Search from '../../../components/reusable/search/Search';

export default function AllUsers() {
  const [filter, setFilter] = useState('');
  const { items: users, footerRef } = useLazyLoadGeneral<IUser>(
    useLazyGetUsers,
    filter,
    15,
  );
  const { classes } = useStyles(theme);

  return (
    <Box>
      <Search
        fullWidth
        value={filter}
        onChange={setFilter}
        className={classes.peopleListSearch}
      />
      <UsersList users={users} />
      <Box ref={footerRef} mb={1} />
    </Box>
  );
}
